import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useUser } from './AuthContext';
import { fetchUserByUsername } from './utils';
const baseUrl = process.env.REACT_APP_BASE_URL;

// Cookie utility functions
const setCookie = (name, value, days = 7) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict;Secure`;
};

export const getCookie = (name) => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=').map(c => c.trim());
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
};

export const login = async (username, password, setUser) => {
// const baseUrl = process.env.REACT_APP_BASE_URL;

try {
  // Step 1: Get authentication token
  const response = await axios.post(`${baseUrl}/login?schema=public`, {
    username: username,
    password_hash: password,
    last_login: new Date().toISOString()
  });

  const token = response.data.access_token;
  // Store token in cookie instead of localStorage
  

  // Step 2: Fetch user details
  const userDetails = await fetchUserByUsername(username, token);

  console.log(token)
  setCookie('access_token', token);
  setCookie('user_id', userDetails.id)

  const userDetailsToStore = {
    username: userDetails.username,
    first_name: userDetails.first_name,
    last_name: userDetails.last_name,
    email: userDetails.email,
    mobile: userDetails.mobile,
    gender: userDetails.gender,
    date_of_birth: userDetails.date_of_birth,
    profile_image: userDetails.profile_image,
    address: userDetails.address
  };

  localStorage.setItem("userDetails", JSON.stringify(userDetailsToStore));

  // Set user state
  setUser({
    userId: userDetails.id,
    username: userDetails.username,
    access_token: response.data.access_token
  });
  
} catch (error) {
  console.error("Error during login:", error);
  const errorMessage = error.response?.data?.message || error.message || "An error occurred";
  throw errorMessage;
}
};

// Function to sync cart data to backend
// Function to sync cart data to backend
const syncCartDataToBackend = async (cartData) => {
try {
  const token = getCookie('access_token');
  if (!token) {
    throw new Error('No access token found');
  }

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  if (!userDetails || !userDetails.id) {
    console.error("User details missing. Cannot sync cart.");
    return;
  }

  const userId = userDetails.id;
  if (!Array.isArray(cartData) || cartData.length === 0) {
    console.warn("Cart data is empty or not an array.");
    return;
  }

  // Step 1: Create a new cart
  const cartResponse = await axios.post(
    `${baseUrl}/cart/`, 
    { user_id: userId, created_at: new Date().toISOString() },
    { headers: { Authorization: `Bearer ${token}` } }
  );


  // Step 2: Prepare cart items
  const cartItems = cartData
    .filter(item => item.quantity > 0) // Prevent invalid data
    .map(item => ({
      user_id: userId,
      cart_id: cartResponse.data.id,
      product_id: item.productId,
      quantity: item.quantity,
      unit_price: parseFloat(item.unit_price).toFixed(2),
      created_at: new Date().toISOString()
    }));

  if (cartItems.length === 0) {
    console.warn("No valid cart items to sync.");
    return;
  }

  // Step 3: Send cart items to backend
  const responses = await Promise.allSettled(
    cartItems.map(item =>
      axios.post(`${baseUrl}/cart_items/?schema=public`, item, {
        headers: { Authorization: `Bearer ${token}` }
      })
    )
  );

  // Log failed requests
  responses.forEach((result, index) => {
    if (result.status === "rejected") {
      console.error(`Failed to sync cart item ${cartItems[index].product_id}:`, result.reason);
    }
  });


} catch (error) {
  console.error("Error syncing cart data:", error);
  throw new Error("Error syncing cart data.");
}
};


function generateUniqueCode(length = 10) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789"; // A-Z and 1-9 (no 0 to avoid confusion)
  let code = "";
  for (let i = 0; i < length; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return code;
}


export const signup =  async(username,first_name, last_name, email, mobile, password, dateOfBirth) =>
{
  const dateOfBirth1 = "1978-01-09";
  try{
    await axios.post(`${baseUrl}/users/signup/?schema=public`, {
      username: username,
      first_name: first_name,
      last_name: last_name,
      email: email,
      mobile: mobile,
      is_active: true,
      date_of_birth: dateOfBirth1,
      address: {},
      profile_image: "",
      role: "user",
      gender: "",
      password_hash: password,
      ucode: generateUniqueCode(),
      created_at: new Date().toISOString()
    });
  }catch (error) {
    console.error("Error Creating Account:", error);

    // More detailed error handling
    if (error.response) {
      // The server responded with a status code outside of the range 2xx
      console.error("Response error:", error.response.data);
      console.error("Status code:", error.response.status);
      throw new Error(error.response.data.detail || "Error creating account");
    } else if (error.request) {
      // The request was made but no response was received
      console.error("Request error:", error.request);
      throw new Error("No response from server");
    } else {
      // Something went wrong in setting up the request
      console.error("Error message:", error.message);
      throw new Error("Error in setting up the request");
    }
  }
}

export const isLoggedIn = () => {
  const access_token = getCookie('access_token');
  const userDetails = sessionStorage.getItem("userDetails");
  
  if (access_token && userDetails) {
    return true;
  }
  return false;
};

// Add logout function to clean up cookies
export const logout = () => {
  deleteCookie('access_token');
  sessionStorage.removeItem("userDetails");
};

// Update getAccesstoken utility
export const getAccesstoken = () => {
  return getCookie('access_token');
};




// export const getUserRole = () =>{
//   const userDetails = sessionStorage.getItem("userDetails");
//   if(userDetails){
//     return userDetails ? userDetails.role : null;
//   }
// }

export const forgotPassword = async(user_email) => {
  try {
    const response = await axios.post(`${baseUrl}/users/reset/forgot-password/`, {
      email: user_email
    });
    return response.data
  }catch(error){
    throw error;
  }
};


export const resetPassword = async(encrypted_token, password_hash) => {
  try{

    const response = await axios.post(`${baseUrl}/users/reset/reset-password/`, {
      encrypted_token: encrypted_token,
      password_hash: password_hash

    });
    console.log(response)
  }catch(err){
    throw err;
  }
}